import { render, staticRenderFns } from "./PhonePatient.vue?vue&type=template&id=ec0bf066&scoped=true"
import script from "./PhonePatient.vue?vue&type=script&lang=js"
export * from "./PhonePatient.vue?vue&type=script&lang=js"
import style0 from "./PhonePatient.vue?vue&type=style&index=0&id=ec0bf066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0bf066",
  null
  
)

export default component.exports